import { DrillService } from './DrillService'

import {
  AppUtil,
  SchoolUtil,
  BrowserUtil,
  DateUtil,
  StringUtil,
  DrillUtil,
  IReport,
  AppVersion,
  DateWrapper,
  UnitUtil,
} from 'kuaidong-lib'

export interface IUserInfo {
  user_no?: number
  user_id?: string
  nick_name: string
  head_img_url: string
  jump_rope_hall_of_frame?: boolean
  school_info?: {
    school: string
    class_grade: number
    class_no: number
  }
}

export type AppealReasonType = 'appeal_norope' | 'double_jump' | 'appeal_fake_people'
export const NOROPE_STATUS_INIT = 'init'
export const NOROPE_STATUS_IN_PROGRESS = 'inProgress'
export const NOROPE_STATUS_DONE = 'done'
export const NOROPE_TREATMENT_ACCEPT = 'accept'
export const NOROPE_TREATMENT_REJECT = 'reject'

// 用户排行榜设定
export const RANK_AUTHORITY_PUBLIC = 'public' // 完全公开
export const RANK_AUTHORITY_SCHOOL_PUBLIC = 'school_public' // 学校公开
export const RANK_AUTHORITY_PRIVATE = 'private' // 私有，不公开
export const RANK_AUTHORITY_CLOSE_VIDEO = 'close_video' // 用户主动关闭了视频上传

// 名人堂的常量
export const HALL_CAN_NOT_APPLY = 'can_not_apply' // 不能申请
export const HALL_ALREADY_IN_HALL = 'already_in_hall' //  已经在名人堂
export const HALL_RECORD_REJECTED = 'record_rejected' // 该报告申请被拒绝
export const HALL_RECORD_APPLIED = 'record_applied' // 该报告已申请
export const HALL_OTHER_RECORD_APPLIED = 'other_record_applied' // 其他报告已申请，审核中
export const HALL_CAN_APPLY = 'can_apply' // 可以申请

// 报告的场景
export const SCENE_TYPE_PUBLIC = 'scene_public' // 来自全局排行榜
export const SCENE_TYPE_SCHOOL = 'scene_school' // 来自学校榜
export const SCENE_TYPE_GRADE = 'scene_grade' // 来自年级榜
export const SCENE_TYPE_CLASS = 'scene_class' // 来自班级榜
export const SCENE_TYPE_SELF = 'scene_self' // 来自全局排行榜
export const SCENE_TYPE_UNDER_SCHOOL = [SCENE_TYPE_SCHOOL, SCENE_TYPE_GRADE, SCENE_TYPE_CLASS] // 在学校范围内

export const CrazyRopeJumpRopeDrills = [
  'jump_rope_free',
  'jump_rope_time',
  'jump_rope_landscape_2007',
  'jump_rope_30sec',
]

export class ReportResult {
  public data: IReport
  public reportId: string
  public currentUserId?: string
  public isUnderApp: boolean
  public from_scene_type = '' // 来自场景，默认为空

  public static async getRemoteOrLocalVideo(
    recordId: string,
    remoteUrl: string,
    remoteCover: string
  ): Promise<{ video: string; cover: string }> {
    if (remoteUrl) {
      return { video: remoteUrl, cover: remoteCover }
    }
    let url = ''
    // 本地文件file:// 安全问题肯定不可行
    try {
      if (await AppUtil.isUnderApp()) {
        url = await AppUtil.getLocalScreenRecord(recordId)
        if (!remoteCover) {
          remoteCover = await AppUtil.getVideoPreviewImage(recordId)
        }
      }
    } catch (e) {
      BrowserUtil.logError(e as any)
    }

    return { video: url, cover: remoteCover }
  }

  constructor(reportId: string, report: IReport) {
    this.reportId = reportId
    this.data = report
    this.isUnderApp = false // 默认设定false
  }

  public get appVersion(): AppVersion {
    return new AppVersion(this.data.app_version)
  }

  public get schoolName(): string {
    if (this.data.user_info.school_info && this.data.user_info.school_info.school) {
      return this.data.user_info.school_info.school
    } else {
      return ''
    }
  }

  public get clazzName(): string {
    if (this.data.user_info.school_info && this.data.user_info.school_info.class_grade) {
      return SchoolUtil.buildClazzName(
        this.data.user_info.school_info.class_grade,
        this.data.user_info.school_info.class_no
      )
    } else {
      return ''
    }
  }

  public get avatarUrl(): string {
    let result = this.data.user_info.head_img_url
    if (!result) {
      result = 'https://www.tiantiantiaosheng.com/icon_512.png'
    }
    return result
  }

  // drill的代号
  public get drill(): string {
    if (this.data.drill_info) {
      return this.data.drill_info.name
    } else {
      return ''
    }
  }

  // drill对应的单位，得分/次数
  public get drillUnit(): string {
    let result = '得分'
    if (this.data.drill_info) {
      if (this.data.drill_info.drill_type === 'count') {
        result = '次数'
      }
    }
    return result
  }

  // 判断是否是云上运动会
  public get isCloudSportMetting(): boolean {
    return (
      this.data.event_type === 'activity' &&
      ['athletics_official', 'athletics_official_free', 't_athletics_official', 't_athletics_official_free'].includes(
        this.data.event_id
      )
    )
  }

  // 判断是否疯狂跳绳中的跳绳项目，有可能是非跳绳项目
  public get isCrazyJumpRope(): boolean {
    return !!this.drill && this.drill.startsWith('jump_rope_')
  }

  public get isGolf(): boolean {
    return !!this.drill && this.drill.startsWith('golf_')
  }

  public get isBoxing(): boolean {
    return !!this.drill && this.data.drill_info.container_type === 'boxing'
  }

  public get isSportQA(): boolean {
    return !!this.drill && this.data.drill_info.playing_type === 'qa_sports_science'
  }

  public get isJogging(): boolean {
    return !!this.drill && this.drill.startsWith('slowrunning_')
  }

  public get isTXPVideo(): boolean {
    return !!this.drill && this.drill === 'txp_video_lesson_2206'
  }

  public get userName(): string {
    return this.data.user_info.nick_name
  }

  public get scroeInfo(): string {
    if (!this.data.official_grade) return ''
    return `${this.data.user_info.school_info?.class_grade_str}|${this.data.user_info.gender === 'M' ? '男' : '女'}`
  }

  public get showCalories(): number {
    if (this.data.burned_calories) {
      return Math.round(this.data.burned_calories / 100) / 10
    } else {
      return 0
    }
  }

  public get hasCalo(): boolean {
    if (DrillUtil.isDistanceDrill(this.data)) {
      return true
    }
    return this.showCalories > 0
  }

  public get userLevel(): number {
    return this.data.user_info.level_no || 0
  }

  public get score(): number | string {
    return DrillService.buildScoreStr(
      this.data.metric_amount,
      this.data.drill_info.display_metric_base,
      this.data.drill_info.metric_type,
      this.data.drill_info.display_metric_unit
    )
  }

  public get distanceInM(): number | string {
    return this.isJogging
      ? this.data.drill_info.metric_type === 'duration'
        ? UnitUtil.division(this.data.drill_info.finish_amount, this.data.drill_info.display_metric_base)
        : DrillService.buildScoreStr(
            this.data.metric_amount,
            this.data.drill_info.display_metric_base,
            this.data.drill_info.metric_type,
            '',
            1
          )
      : 0
  }

  public get videoUrl(): string {
    if (this.data.video_info) {
      return this.data.video_info.video_url
    } else {
      return this.data.video_url
    }
  }

  public get videoPoster(): string {
    if (this.data.video_info) {
      return this.data.video_info.video_cover_url
    } else {
      return ''
    }
  }

  // 判断视频是横屏还是竖屏
  public get isLandscapeVideo(): boolean {
    if (this.data.video_info) {
      if (this.data.video_info.height > this.data.video_info.width) {
        return false
      }
    }
    return true
  }

  public get isMoveType(): boolean {
    return DrillUtil.isMoveType(this.data.drill_info)
  }

  /**
   * 获取远程的地址，如果远程的为空，获取本地的，都没有给个默认的
   */
  public async getRemoteOrLocalVideo(): Promise<string> {
    if (this.hasClosedVideo) {
      return ''
    }

    let url = ''

    // 本地文件file:// 安全问题肯定不可行
    try {
      if (await AppUtil.isUnderApp()) {
        url = await AppUtil.getLocalScreenRecord(this.reportId)
        if (!this.data.video_info.video_cover_url)
          this.data.video_info.video_cover_url = await AppUtil.getVideoPreviewImage(this.reportId)
      }
    } catch (e) {
      BrowserUtil.logError(e as any)
    }

    return url || this.videoUrl
  }

  // 耗时的逻辑
  public get duration(): number {
    let millseconds = this.data.duration
    if (this.data.score_duration > 0) {
      millseconds = this.data.score_duration
    }
    return Math.round(millseconds / 1000)
  }

  public get durationInMinStr(): string {
    return DateUtil.ms2Str(this.data.score_duration || this.data.duration)
  }

  public get drillName(): string {
    return this.data.drill_info.display_name
  }

  public get drillPic(): string {
    return this.data.drill_info.picture!
  }

  public get drillType(): string {
    return this.data.drill_info.drill_type
  }

  public get showTime(): string {
    return DateUtil.fromString(this.data.record_time).showCustomStr
  }

  public get recordTime(): Date {
    return DateUtil.fromString(this.data.record_time).date
  }

  public get isExpired(): boolean {
    return new DateWrapper(this.data.record_time).date < DateUtil.addDay(new Date(), -14)
  }

  public get isDeleted(): boolean {
    return !!this.data.is_deleted
  }

  // 关闭了上传视频
  public get isCloseUploadVideo(): boolean {
    // return this.data.rank_authority === RANK_AUTHORITY_CLOSE_VIDEO
    return !this.isPermissionShowVideo
  }

  // 是否用户设置权限是否打开视频
  public get isPermissionShowVideo(): boolean {
    if (this.isCurrentUserReport()) {
      // 自己的视频一直可以打开
      return true
    }

    if (this.isUnderApp) {
      // 有优先级的关系，需要理清楚再改
      if (this.from_scene_type === SCENE_TYPE_SELF) {
        // 自己查看使用是true
        return true
      }
      if (this.data.rank_authority === RANK_AUTHORITY_CLOSE_VIDEO) {
        // 关闭了视频，始终不显示视频
        return false
      }
      if (this.from_scene_type === SCENE_TYPE_PUBLIC) {
        // 全局排行榜, 只显示那些公开视频的
        return this.data.rank_authority === RANK_AUTHORITY_PUBLIC
      }
      // 如果在全局排行榜下始终显示视频
      if (this.data.rank_authority === RANK_AUTHORITY_PUBLIC) {
        return true
      }
      if (this.data.rank_authority === RANK_AUTHORITY_SCHOOL_PUBLIC) {
        return this.isUnderSchoolRank()
      }
      if (!this.from_scene_type) {
        // 没有任何场景信息可以显示视频
        return true
      }
      if (this.data.rank_authority === RANK_AUTHORITY_PRIVATE) {
        return false
      }
    }

    return true
  }

  public isUnderSchoolRank() {
    // 是否在学校榜单内
    return SCENE_TYPE_UNDER_SCHOOL.includes(this.from_scene_type)
  }

  // 当前报告各种原因关闭了视频
  public get hasClosedVideo(): boolean {
    return this.isDeleted || this.isCloseUploadVideo
  }

  /**
   * 是否录制视频了
   */
  public get hasRecordVideo(): boolean {
    return true // this.data.record_screen;
  }

  // 成功次数
  public get successCount(): number {
    return this.data.success_count
  }

  public get failCount(): number {
    return this.data.fail_count || 0
  }

  public get avgCountPerMin(): number {
    return Math.round((60 * this.successCount) / this.duration)
  }

  // ============ 对战相关 =============
  public get showBattleScore(): boolean {
    return this.data.room_score_info && this.data.room_score_info.length > 0
  }

  public get orderedScoreInfo(): {
    idx: number
    user_info: IUserInfo
    score: number
  }[] {
    const scoreInfos = this.data.room_score_info
    // return [
    //   {
    //     idx: 1,
    //     user_info: {
    //       nick_name: "test",
    //       head_img_url: "https://cdn.gkid.com/static/data/images/icon_76pt.png"
    //     },
    //     score: 99
    //   },
    //   {
    //     idx: 2,
    //     user_info: {
    //       nick_name: "test",
    //       head_img_url: "https://cdn.gkid.com/static/data/images/icon_76pt.png"
    //     },
    //     score: 98
    //   }
    // ];

    return scoreInfos.map((x: any, idx: number) => {
      x.idx = idx + 1
      return x
    })
  }

  public get canChallenge() {
    // 体测或者广播操 不能挑战
    return (
      this.data.drill_info.playing_type !== 'move' &&
      !this.data.drill_info.is_exam_drill &&
      this.data.drill_info.can_challenge &&
      (!this.data.speed_rate || this.data.speed_rate === 1)
    )
  }

  public async isMine(): Promise<boolean> {
    if (await AppUtil.isUnderApp()) {
      const userData = await AppUtil.getUserData()

      return this.data.user_info.user_id === userData.user_id
    }

    return false
  }

  // ============= 无绳相关 ============
  public get showAppeal() {
    return false
    // return true;
  }

  public get hasNoRope(): boolean {
    return this.data.detection_has_rope.toUpperCase() === 'N'
  }

  public get appealType() {
    if (this.hasUsedDummy) {
      return 'appeal_fake_people'
    } else if (this.hasNoRope) {
      return 'appeal_norope'
    } else if (this.isDoubleJump) {
      return 'double_jump'
    }

    return null
  }

  // 当前能否申诉
  public get noRopeCanAppeal(): boolean {
    if (this.isCurrentUserReport()) {
      // 如果是自己的报告，当前 无绳状态 或者 双跳 状态， 且没有任何申诉记录时，可申诉
      if (this.isNoRopeOrDoubleJump && this.data.no_rope_appeal_status) {
        return this.data.no_rope_appeal_status.status === NOROPE_STATUS_INIT
      }
    }
    return false
  }

  // 当前是否正在申诉中
  public get inAppealProgress(): boolean {
    if (this.isNoRopeOrDoubleJump && this.data.no_rope_appeal_status) {
      return this.data.no_rope_appeal_status.status === NOROPE_STATUS_IN_PROGRESS
    }
    return false
  }

  // 申诉已经完成
  public get appealDone(): boolean {
    if (this.isNoRopeOrDoubleJump && this.data.no_rope_appeal_status) {
      return this.data.no_rope_appeal_status.status === NOROPE_STATUS_DONE
    }
    return false
  }

  public async doAppeal(isValid: boolean, reasonType: AppealReasonType): Promise<any> {
    const result = await AppUtil.httpPOST('/user/drill_record/appeal_no_rope', {
      record_id: this.data.record_id,
      is_valid: isValid,
      reason_type: reasonType,
    })
    return result
  }

  // =============== 名人堂相关 ==============
  // 是否能申请
  public get hallCanApply(): boolean {
    if (this.isCurrentUserReport()) {
      // 只有当前用户才可以
      return this.data.apply_hall_status === HALL_CAN_APPLY
    }
    return false
  }

  // 申请中
  public get hallUnderApply(): boolean {
    if (this.isCurrentUserReport()) {
      // 只有当前用户才可以
      return this.data.apply_hall_status === HALL_RECORD_APPLIED
    }
    return false
  }

  // 是否名人堂人员
  public get isJumpRopeHallFamer() {
    return !!this.data.user_info.jump_rope_hall_of_frame
  }

  public get showApplyCard(): boolean {
    return this.hallCanApply || this.hallUnderApply
  }

  public async doApplyHall(): Promise<any> {
    const result = await AppUtil.httpPOST('/hall_of_frame/apply', {
      record_id: this.data.record_id,
    })
    return result
  }

  public get hasUsedDummy() {
    return this.data.detection_fake_people === 'Fake'
  }

  public get isDoubleJump(): boolean {
    // 是否双跳
    return !!this.data.is_double_jump
  }

  public get isNoRopeOrDoubleJump(): boolean {
    return this.isDoubleJump || this.hasNoRope || this.hasUsedDummy
  }

  // ============== 跳转路径 =============
  public get reportPath(): string {
    return `/crazyrope/drill-report?id=${this.data.record_id}`
  }

  public get appealChoosePath(): string {
    return `/crazyrope/appeal-choose?id=${this.data.record_id}`
  }

  public get appealSuccessPath(): string {
    return `/crazyrope/appeal-success?id=${this.data.record_id}`
  }
  // 校园云比赛视频报告信息
  get competitionDrillInfo() {
    return this.buildCompetitionScoreInfo()
  }

  // ============= 当前用户相关 =============
  public async syncLoginUserId(): Promise<string | undefined> {
    if (await AppUtil.isUnderApp()) {
      const userData = await AppUtil.getUserData()
      if (userData && userData.user_id) {
        this.currentUserId = userData.user_id
      }
    }
    return this.currentUserId
  }

  // 当前报告是否是当前登录用户的
  public isCurrentUserReport() {
    if (this.currentUserId) {
      return this.currentUserId === this.data.user_info.user_id
    }
    return false
  }

  get isPacmanPage() {
    return !!(this.data.drill_info.tags && this.data.drill_info.tags.includes('Pacman'))
  }

  get isDanceDrill() {
    return !!(this.data.drill_info.playing_type === 'move_ar')
  }

  get isRhythmMaster() {
    return this.data.drill_info.playing_type.toLowerCase() === 'rhythm_taiko_master'
  }

  public async ossFrozenUnlock() {
    // 构建video key
    const videoOssKey = new URL(this.videoUrl).pathname.replace(/^\//, '')
    return AppUtil.httpPOST(
      `${process.env.VUE_APP_CRAZYROPE_API}/oss/video_restore`,
      {
        video_key: videoOssKey,
      },
      {},
      false,
      false
    )
  }

  public get battleResult() {
    return this.buildBattleResult()
  }

  public buildBattleResult(): any {
    return null
  }

  public buildCompetitionScoreInfo() {
    const duration = this.data.score_duration || this.data.duration

    return [
      { label: '评价：', val: this.data.score_grade },
      { label: '时间：', val: DateUtil.ms2Str(duration) },
      ...(this.data.drill_info?.name.startsWith('jump_rope_')
        ? [
            { label: '中断次数：', val: this.data.interrupt_count },
            { label: '最多连续：', val: this.data.max_combo_count },
            {
              label: '速度(分钟)：',
              val: Math.round((this.data.success_count * 60000) / duration),
            },
          ]
        : [{ label: '次数：', val: this.data.success_count }]),
      { label: '热量(大卡)：', val: Math.round((this.data.burned_calories || 0) / 100) / 10 },
    ]
  }
}

export class ReportService {
  static _currentResult?: ReportResult

  /**
   * 获得报告内容
   * @param reportId 报告id
   * @param scene_type 场景, server会根据场景返回对应的视频权限
   * @returns 报告内容
   */
  public static async getReportById(reportId: string, scene_type?: string): Promise<ReportResult> {
    // eslint-disable-next-line no-console
    // console.log(`start get record ${reportId}`);
    let url = `${process.env.VUE_APP_CRAZYROPE_API}/user/drill_report_info?drill_record_id=${reportId}`
    if (scene_type) {
      url = `${url}&scene_type=${scene_type}`
    }

    const result: IReport = await AppUtil.httpGET(url, {}, {}, false, false)

    // eslint-disable-next-line no-console
    // console.log(`finish get record ${reportId} - ${JSON.stringify(result)}`);
    const resp = new ReportResult(reportId, result)
    resp.isUnderApp = await AppUtil.isUnderApp()
    await resp.syncLoginUserId()
    this._currentResult = resp
    return resp
  }

  // 本都读缓存或者远程去获取
  public static async getCachedReportById(reportId: string): Promise<ReportResult> {
    if (this._currentResult) {
      return this._currentResult
    }
    const result = await this.getReportById(reportId)
    await result.syncLoginUserId()
    return result
  }

  // 获取对应的智能评价
  public static async getIntelligentEvaluation(reportId: string): Promise<IIntelligentEvaluationResult> {
    const url = `${process.env.VUE_APP_CRAZYROPE_API}2/jump_rope/intelligent_evaluation/report_detail`
    return await AppUtil.httpGET(url, { record_id: reportId })
  }
}

// 智能评价报告
export interface IIntelligentEvaluationResult {
  report_data: { [key: string]: string }
}

/**
 * 报告点赞逻辑
 **/
export class ReportLikeService {
  constructor(public reportResult: ReportResult) {}

  get likeCount() {
    // 当前点赞数
    return this.reportResult.data.thumbed_counts
  }

  get likeCountStr() {
    return StringUtil.numberToShortK(this.likeCount)
  }

  get hasLiked() {
    // 当前用户是否已经点赞
    return this.reportResult.data.current_user_thumbed
  }

  async doLike() {
    this.reportResult.data.thumbed_counts += 1
    this.reportResult.data.current_user_thumbed = true
    // 请求
    return await this._callLike(true)
  }

  async cancelLike() {
    if (this.reportResult.data.thumbed_counts > 0) {
      this.reportResult.data.thumbed_counts -= 1
    }
    this.reportResult.data.current_user_thumbed = false
    // 请求
    return await this._callLike(false)
  }

  async _callLike(thumbed: boolean) {
    return await AppUtil.httpPOST(
      `${process.env.VUE_APP_CRAZYROPE_API}/user/drill_record/thumb`,
      {
        record_id: this.reportResult.data.record_id,
        thumbed,
      },
      {},
      false,
      false
    )
  }
}

export class JkcReportService {
  public static readonly KeyPrefix = 'ttts.jck.pub.'
  // 设定发布
  public static setPubed(recordId: string) {
    localStorage.setItem(`${this.KeyPrefix}${recordId}`, new Date().getTime() + '')
  }

  // 判断是否已经发布
  public static isPubed(recordId: string): boolean {
    return !!localStorage.getItem(`${this.KeyPrefix}${recordId}`)
  }
}
